
export const device = {
    pc2: '@media screen and (max-width: 1550px)',
    pc: '@media screen and (min-width: 1024px) and (max-width: 1300px)',
    tablet: '@media screen and (min-width: 601px) and (max-width: 1023px)',
    mobile: '@media screen and (max-width: 600px)',
};

